import { withLayout } from '@lib/rn-utils';
import styled, { css } from 'styled-components';

export const clsPrefix = 'ui-segmented-control';

const itemRadiusMixin = css`
  border-radius: 2px;

  &.start {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  &.end {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;

const lightStyle = css`
  &:hover:not(:disabled) {
    &:not(.active) {
      color: ${({ theme }) => theme.color.tint.action};
    }
    background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover')};
  }

  ${({ theme }) => css`
    color: ${theme.color.tint.secondary};
  `};

  &.active,
  &.default {
    color: ${({ theme }) => theme.color.tint.actionDark};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover', 'dark')};
    }
  }

  &.default {
    background: ${({ theme }) => theme.color.state.active};
  }
`;

const darkStyle = css`
  color: ${({ theme }) => theme.color.tint.secondaryDark};

  &:hover:not(:disabled) {
    &:not(.active) {
      color: ${({ theme }) => theme.color.tint.actionDark};
    }
    background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover', 'dark')};
  }

  &.active,
  &.default {
    color: ${({ theme }) => theme.color.tint.action};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.createOverlayColor('transparent', 'hover', 'light')};
    }
  }

  &.default {
    background: ${({ theme }) => theme.color.state.activeDark};
  }
`;

const _SegmentedItem = styled.button`
  all: unset;
  outline: none;
  flex: 1;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.3s;

  text-align: center;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  ${lightStyle};
  ${itemRadiusMixin};
  ${({ theme }) => theme.mappedTypography.overline.default};

  &.on-dark {
    ${darkStyle};
  }
`;

export const SegmentedItem = withLayout(_SegmentedItem);

export const SegmentedControlSC = styled.div`
  width: 100%;
  height: 100%;
  min-height: 32px;

  position: relative;
  overflow: hidden;

  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0;

  border-radius: ${({ theme }) => theme.radius.small}px;
  border: 2px solid ${({ theme }) => theme.color.border.emphasis};
  transition: all 0.3s;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.border.emphasis, 'hoverBorder')};
  }

  &.on-dark {
    border-color: ${({ theme }) => theme.color.border.emphasisDark};

    &:hover:not(:disabled) {
      border-color: ${({ theme }) =>
        theme.createOverlayColor(theme.color.border.emphasisDark, 'hoverBorder', 'dark')};
    }
  }
`;

export const SegmentedFloat = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;

  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);

  ${itemRadiusMixin};

  background: ${({ theme }) => theme.color.state.active};

  &.on-dark {
    background: ${({ theme }) => theme.color.state.activeDark};
  }
`;
